import { render, staticRenderFns } from "./properties-block.vue?vue&type=template&id=41fd53aa&scoped=true"
import script from "./properties-block.vue?vue&type=script&lang=js"
export * from "./properties-block.vue?vue&type=script&lang=js"
import style0 from "./properties-block.vue?vue&type=style&index=0&id=41fd53aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd53aa",
  null
  
)

export default component.exports